import React, { useEffect } from 'react';
import { getFramework, getStageIndexByMousePointY, useIdentity } from '@/framework';
import { getLastMousePoint, setLastMousePoint, TouchKit } from '@/utils/event-kit';
import dragLayerPluginState, { getDragLayerState, useDragLayerState } from './states/drag-state';
import './drag-layer.less';
import { IExportPlugin, PluginType } from '@/version-types';
import { DragLayerPlugin } from './drag-layer';

const DragLayerPluginView: React.FC = React.memo(() => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const { setDragData } = getDragLayerState(identity);
    const dragData = useDragLayerState()((state) => state.dragData);

    useEffect(() => {
        const handleDragOverLayer = framework.events.onDragOverLayer((e) => {
            //TODO 先隐藏这个事件 是用来直接放入到有mask得img图层里面的
            console.log('onDragOverLayer', e);
        });

        const handleDragLeaveLayer = framework.events.onDragLeaveLayer((e) => {
            console.log('onDragLeaveLayer', e);
        });

        const handleDropLayer = framework.events.onDropLayer(async (e) => {
            console.log('onDragLayer', e);
            e.preventDefault();
            e.stopPropagation();
            setLastMousePoint(e.clientX, e.clientY);
            const lastMousePoint = getLastMousePoint();

            const currentStageIndex = getStageIndexByMousePointY(identity, lastMousePoint.y);
            const stageIndex = framework.stage.getActiveStageIndex();

            if (currentStageIndex !== stageIndex) {
                framework.stage.setActiveStageIndex(currentStageIndex);
            }

            // 拖拽用户文件到舞台
            if (!dragData) {
                if (e?.dataTransfer?.files) {
                    framework.getInstance(DragLayerPlugin).emitUploadFile(e?.dataTransfer?.files, lastMousePoint);
                }
                return;
            }

            // 拖拽列表素材到舞台
            dragData.callback?.();

            // 拖动完成，触发一次全局的mouseup
            TouchKit.fireMouseup();
            console.log('dragData', dragData);
            setDragData(null);
        });

        return () => {
            framework.events.off(handleDragOverLayer);
            framework.events.off(handleDragLeaveLayer);
            framework.events.off(handleDropLayer);
        };
    }, [dragData]);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 3,
    name: 'drag-layer-plugin',
    render() {
        return <DragLayerPluginView />;
    },
    createInstance({ identity }) {
        return [{ key: 'DragLayerPlugin', value: new DragLayerPlugin(identity) }];
    },
    createState() {
        return [dragLayerPluginState];
    },
    destroy({ getInstance }) {
        getInstance(DragLayerPlugin).destroy();
    },
};

export default exportPlugin;
